import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../services/authContext';
import '../../css/Notifications.css';

function NotificationBell() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    if (!user || user.role !== 'user') {
      setCount(0);
      return undefined;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const data = await api.getNotifications();
        if (!cancelled) {
          setCount(data.count || 0);
          setItems(data.items || []);
        }
      } catch {
        if (!cancelled) {
          setCount(0);
          setItems([]);
        }
      }
    };

    load();
    const interval = setInterval(load, 60000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  if (!user || user.role !== 'user') {
    return null;
  }

  return (
    <div className="notification-bell" ref={panelRef}>
      <button
        type="button"
        className="notification-bell__toggle"
        aria-label={`Уведомления${count ? `: ${count} непрочитанных` : ''}`}
        onClick={() => setOpen((value) => !value)}
      >
        🔔
        {count > 0 && <span className="notification-bell__badge">{count > 9 ? '9+' : count}</span>}
      </button>

      {open && (
        <div className="notification-bell__panel">
          <div className="notification-bell__header">Уведомления</div>
          {items.length === 0 ? (
            <p className="notification-bell__empty">Нет новых уведомлений</p>
          ) : (
            <ul className="notification-bell__list">
              {items.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.href}
                    className="notification-bell__item"
                    onClick={() => setOpen(false)}
                  >
                    <strong>{item.title}</strong>
                    <span>{item.message}</span>
                    {item.psychologist?.username && (
                      <span className="notification-bell__meta">от {item.psychologist.username}</span>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          )}
          <Link to="/profile/access" className="notification-bell__footer" onClick={() => setOpen(false)}>
            Запросы доступа и напоминания
          </Link>
        </div>
      )}
    </div>
  );
}

export default NotificationBell;
